import React from 'react';
export const SilkBenefits = () => {
  return <section className="mb-12" data-id="element-256">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-257">
        Why Silk is the Ultimate Anti-Aging Weapon
      </h2>
      <p className="text-gray-700 mb-6" data-id="element-258">
        When Dr. Grant finally discovered silk's anti-aging properties,
        everything clicked:
      </p>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-259">
        "Silk isn't just smooth - it's the only fabric that actually works WITH
        your skin's natural repair processes instead of against them."
      </blockquote>
      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-260">
        The Sericin Protein Shield Discovery
      </h3>
      <p className="text-gray-700 mb-6" data-id="element-261">
        100% Mulberry silk contains a unique protein coating called sericin that
        creates what Dr. Grant calls the "ultimate anti-aging environment":
      </p>
      <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-262">
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-263">
          <h4 className="font-bold text-blue-800 mb-2" data-id="element-264">
            Zero-Friction Surface
          </h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-265">
            <li data-id="element-266">
              Silk's smooth protein fibers eliminate nightly micro-abrasions
            </li>
            <li data-id="element-267">
              Hair and skin glide effortlessly, preventing friction stress and
              damage
            </li>
            <li data-id="element-268">No tugging, pulling, or compression damage</li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-269">
          <h4 className="font-bold text-blue-800 mb-2" data-id="element-270">
            Moisture Preservation Technology
          </h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-271">
            <li data-id="element-272">
              Unlike cotton, silk doesn't absorb your skin's natural moisture
            </li>
            <li data-id="element-273">
              Expensive skincare products stay on your face, not in your
              pillowcase
            </li>
            <li data-id="element-274">Skin remains hydrated throughout the 8-hour repair cycle</li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-275">
          <h4 className="font-bold text-blue-800 mb-2" data-id="element-276">
            Protein Infusion Benefits
          </h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-277">
            <li data-id="element-278">
              Silk contains 18 amino acids that are the building blocks for skin
              regeneration
            </li>
            <li data-id="element-279">
              Natural sericin coating provides gentle, continuous nourishment
            </li>
            <li data-id="element-280">
              Proteins are small enough to be absorbed by skin during extended
              contact
            </li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-281">
          <h4 className="font-bold text-blue-800 mb-2" data-id="element-282">
            Anti-Bacterial Protection
          </h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-283">
            <li data-id="element-284">
              Silk's natural antimicrobial properties prevent bacteria buildup
            </li>
            <li data-id="element-285">
              Cleaner sleep environment reduces inflammation and breakouts
            </li>
            <li data-id="element-286">Hypoallergenic surface ideal for sensitive, aging skin</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-287">
        <div className="md:w-1/2" data-id="element-288">
          <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-289">
            The Overnight Transformation Process
          </h3>
          <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-4" data-id="element-290">
            "Think of silk as creating a 'healing chamber' for your face," Dr.
            Grant explains. "Instead of fighting damage all night, your skin can
            focus entirely on repair and regeneration."
          </blockquote>
          <h4 className="font-bold text-blue-800 mb-2" data-id="element-291">
            The 8-Hour Repair Cycle:
          </h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-292">
            <li data-id="element-293">
              Hours 1-2: Elimination of friction allows immediate stress relief
            </li>
            <li data-id="element-294">
              Hours 3-5: Preserved moisture creates an optimal healing
              environment
            </li>
            <li data-id="element-295">
              Hours 6-8: Amino acid absorption supports collagen production
            </li>
          </ul>
        </div>
        <div className="md:w-1/2" data-id="element-296">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6kAKRCFyZtLKEBW7TSEE3t/AI-Generated-Image-3_%281%29.png" alt="Woman sleeping peacefully on a luxurious silk pillowcase" className="rounded-lg shadow-lg w-full" data-id="element-297" />
        </div>
      </div>
    </section>;
};